/**
 * @file: 卧柜层板 render 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as CabinetRenderCore from './renderCore/index';
import * as UIToolkit from '../../UIToolkit/index';
import { Watcher } from '../../observe/index';

export default function render(cube: CubeNode): boolean {
    UIToolkit.updateFreeLayerInShelfSize(cube.id);

    // 卧柜层板尺寸
    new Watcher(() => {
        CabinetRenderCore.cabinetPosition(cube);
    });

    return true;
}
